import { useState } from "react";

// ✅ Lahat ng PDF files sa /public folder
const PDF_FILES = [
  { name: "Introduction", file: "PRPO_USER-MANUAL_1Introduction.pdf" },
  { name: "Purchase Requisition", file: "PRPO_USER-MANUAL_2Purchase Requisition.pdf" },
  { name: "My Purchase", file: "PRPO_USER-MANUAL_3MyPurchase.pdf" },
  { name: "Purchase Order", file: "PRPO_USER-MANUAL_4PurchaseOrder.pdf" },
  { name: "My Purchase Order", file: "PRPO_USER-MANUAL_5MyPurchaseOrder.pdf" },
  { name: "PO Receiving", file: "PRPO_USER-MANUAL_6POreceiving.pdf" },
  { name: "Invoice Transmittal", file: "PRPO_USER-MANUAL_7InvoiceTransmittal.pdf" },
  { name: "Goods Receipt", file: "PRPO_USER-MANUAL_8GoodsReceipt.pdf" },
  { name: "Goods Receipt List", file: "PRPO_USER-MANUAL_9GoodsReceiptList.pdf" },
  { name: "Inventory List", file: "PRPO_USER-MANUAL_10InventoryList.pdf" },
  { name: "Stock Adjustment", file: "PRPO_USER-MANUAL_11StockAdjustment.pdf" },
  { name: "Stock Adjustment List", file: "PRPO_USER-MANUAL_12StockAdjustmentList.pdf" },
  { name: "Material Request Form", file: "PRPO_USER-MANUAL_13MaterialRequestForm.pdf" },
  { name: "Item Requests", file: "PRPO_USER-MANUAL_14ItemRequests.pdf" },
  { name: "Item Request Date Folders", file: "PRPO_USER-MANUAL_15Item RequestDateFolders.pdf" },
  { name: "Goods Issue", file: "PRPO_USER-MANUAL_16GoodsIssue.pdf" },
  { name: "Fuel Request Form", file: "PRPO_USER-MANUAL_17FuelRequestForm.pdf" },
  { name: "Fuel Request List", file: "PRPO_USER-MANUAL_18FuelRequestList.pdf" },
  { name: "Fuel Request Approval", file: "PRPO_USER-MANUAL_19FuelRequestApproval.pdf" },
];

// Download single file
async function downloadFile(filePath, fileName) {
  try {
    const response = await fetch(filePath);
    if (!response.ok) throw new Error("File not found: " + filePath);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}

// Download DOCX manual
async function downloadDocx() {
  const ok = await downloadFile("PR-PO-USER-MANUAL.docx", "PR-PO USER MANUAL.docx");
  if (!ok) alert("Hindi mahanap ang file. Siguraduhing nandito sa /public: PR-PO-USER-MANUAL.docx");
}

// Download ALL PDFs one by one with delay
async function downloadAllPDFs(setProgress, setDownloading) {
  setDownloading(true);
  let success = 0;
  let failed = [];
  for (let i = 0; i < PDF_FILES.length; i++) {
    const pdf = PDF_FILES[i];
    setProgress({ current: i + 1, total: PDF_FILES.length, name: pdf.name });
    const ok = await downloadFile(pdf.file, pdf.file);
    if (ok) success++;
    else failed.push(pdf.name);
    await new Promise((r) => setTimeout(r, 800)); // delay para hindi ma-block browser
  }
  setDownloading(false);
  setProgress(null);
  if (failed.length > 0) {
    alert(`✅ Na-download: ${success}\n❌ Hindi nahanap (${failed.length}):\n${failed.join("\n")}\n\nSiguraduhin na nandoon sila sa /public folder!`);
  } else {
    alert(`✅ Lahat ng ${success} PDFs na-download!`);
  }
}

const modules = [
  {
    id: "dashboard", code: "DASH", title: "Dashboard", icon: "📊",
    color: "#0369a1", glow: "rgba(3,105,161,0.12)",
    description: "Provides a real-time overview of procurement activities and key metrics across the entire system.",
    features: [
      "Total Documents count (PRs, POs)", "Pending / Approved / Rejected stats",
      "Top 3 Rated Purchase Requests & Orders", "Monthly Trends bar graph",
      "Status Distribution pie chart (Approved, Drafts, Pending, Rejected)",
      "Quick actions: Update Profile, Create New PR, Track Requests",
    ],
    steps: [
      { title: "Viewing Key Metrics", items: ["Total Documents – total number of procurement documents.", "Pending – documents awaiting approval.", "Approved – completed procurement documents.", "Rejected – disapproved documents."] },
      { title: "Charts & Graphs", items: ["Top 3 Rated Purchase Requests / Orders: select Day, 3 Days, Week, or Month.", "Monthly Trends: bar graph of POs created each month.", "Status Distribution: pie chart showing Approved, Drafts, Pending, Rejected %."] },
      { title: "Quick Actions", items: ["Update Profile – modify your profile information.", "Create New PR – start a new purchase request.", "Track Requests – monitor the status of existing requests."] },
    ],
  },
  {
    id: "pr", code: "PR", title: "Purchase Request", icon: "📋",
    color: "#1d4ed8", glow: "rgba(29,78,216,0.12)",
    description: "A purchase request (PR) is a document used to formally request the purchase of goods or services. Create, manage, view, edit, and delete purchase requests with multi-level approval.",
    features: ["Create PR with Information, Items, and Attachments", "Multi-level approval routing", "Save as draft or submit for approval", "View, Edit, and Delete existing PRs", "File attachments (PDF, JPG, PNG, DOCX up to 10MB)", "Auto-calculate Total Budget"],
    steps: [
      { title: "Create Purchase Request", items: ["Navigate to Purchase Request → Create Purchase Req.", "Part 1 – PR Information: Fill in Date Needed, Charged To Dept, Requesting Company, and other required fields.", "Part 2 – Add Items: Click 'Add Item' for each item. Enter Item Description, Qty, UOM, Size (if applicable), Specifications, Material, and Unit Price. Total Budget calculates automatically. Use 'X' to remove an item.", "Part 3 – Attachments: Drag/drop or browse files (PDF, JPG, PNG, DOCX, up to 10MB). Add a description for each file.", "Click 'Save Draft' to save, or 'Submit' to send for approval.", "Use Next/Previous to navigate sections. Load Draft to retrieve saved data."] },
      { title: "My Purchase Request (View / Edit / Delete)", items: ["Navigate to Purchase Request → My Requests.", "View – click a request to see full details including company info, dates, and relevant data.", "Edit – click Edit to modify information of an existing PR.", "Delete – click Remove. A confirmation dialog appears before permanently deleting the PR Header, all items, and attachments."] },
    ],
  },
  {
    id: "quotation", code: "QUO", title: "Quotation", icon: "💬",
    color: "#0369a1", glow: "rgba(3,105,161,0.12)",
    description: "Manage and compare quotations from different suppliers. Link quotations to purchase requests and facilitate the selection of the best vendor offer.",
    features: ["Create and manage supplier quotations", "Compare quotations from multiple vendors", "Link quotations to purchase requests", "Vendor assignment from quotation", "Support for VAT and Discount options"],
    steps: [{ title: "Managing Quotations", items: ["Navigate to Quotation in the left menu.", "Search for existing quotations or create a new one.", "Enter supplier details, item pricing, VAT, and discount information.", "Compare multiple supplier quotations side by side.", "Select the best quotation to proceed to Purchase Order."] }],
  },
  {
    id: "po", code: "PO", title: "Purchase Order", icon: "🛒",
    color: "#0f766e", glow: "rgba(15,118,110,0.12)",
    description: "Create and manage purchase orders from approved PRs. Includes PO creation, PO receiving, invoice transmittal, and goods receipt linking.",
    features: ["Create PO with Charging Company, Vendor, Ship To Details", "PO Items: Qty, UOM, Description, Spec, Unit Price, Discount %, VAT", "Remarks & Approvals section", "PO Receiving – receive goods against PO", "Invoice Transmittal – search and save invoice info", "View, Edit, Delete POs"],
    steps: [
      { title: "Create Purchase Order", items: ["Navigate to Purchase Order → My PO.", "Fill in Charging Company, Vendor Information, and Ship To Details.", "Go to 'Purchase Order Items' tab: Add items with Reference PR Item, Quantity, UOM, Item Description, Specification, Unit Price, Discount %, VAT & Discount Options.", "Go to 'Remarks & Approvals' tab: Enter special instructions or remarks.", "Save as draft, Load Draft, or Create the purchase order.", "Use Previous/Next to navigate between sections."] },
      { title: "My Purchase Order (View / Edit / Delete / GR)", items: ["Navigate to Purchase Order → My Purchase Order.", "View Goods Receipts – click a specific PO to view associated GRs.", "PO Details – view complete details of a selected PO.", "Edit – modify information of an existing PO.", "Delete – confirmation dialog appears before permanently deleting."] },
      { title: "PO Receiving", items: ["Navigate to Purchase Order → PO Receiving.", "Click 'Search PO' to find a specific purchase order.", "Type the PO number and select from search results.", "Purchase Order Information will be displayed for receiving."] },
      { title: "Invoice Transmittal", items: ["Navigate to Purchase Order → Invoice Transmittal.", "Click 'Search Invoice' to find a specific invoice.", "Type the invoice number and select from results.", "Click 'Save Transmittal' to save the invoice transmittal information."] },
    ],
  },
  {
    id: "gr", code: "GR", title: "Goods Receipt", icon: "📦",
    color: "#15803d", glow: "rgba(21,128,61,0.12)",
    description: "Record and verify incoming goods against purchase orders. Auto-updates inventory upon receipt and supports revert and delete operations.",
    features: ["Receive items from approved Purchase Orders", "Fill GR Header: Vendor, Received By, connect to PO", "Add GR Items: Item Code, Description, Qty, UOM", "Save GR and auto-update inventory stock", "Revert GR (cannot be undone)", "Delete GR (cannot be undone)"],
    steps: [
      { title: "Create Goods Receipt", items: ["Navigate to Goods Receipt (GR) → Goods Receipt.", "View list of saved Goods Receipts.", "Fill in GR Header: Vendor, Received By, and connect to a PO.", "Add GR Items: specify Item Code, Description, Quantity, UOM, etc.", "Click 'Save GR' to save and auto-update inventory."] },
      { title: "GR View List (Revert / Delete)", items: ["Navigate to Goods Receipt (GR) → GR View List.", "View – click a GR to see its full details.", "Revert GR – specify quantities to revert for each item. This action CANNOT be undone.", "Delete GR – permanently deletes the record. This action CANNOT be undone."] },
    ],
  },
  {
    id: "inventory", code: "INV", title: "Inventory / Current Stocks", icon: "🏭",
    color: "#0369a1", glow: "rgba(3,105,161,0.12)",
    description: "Real-time inventory visibility across all warehouses. Monitor stock levels, view batch breakdown, stock movement history, and perform stock adjustments.",
    features: ["View total SKUs, total units, low stock, out-of-stock items", "Batch breakdown, stock movement history, MR usage history", "Delete inventory record (removes ALL batches)", "New Stock Adjustment: Increase, Decrease, or Physical Count", "Stock Adjustment History with before/after quantities", "Reverse stock adjustment"],
    steps: [
      { title: "View Inventory / Current Stock", items: ["Navigate to Inventory → Inventory List.", "View current stock levels: total SKUs, total units, low stock, out-of-stock.", "Click an item for Details: batch breakdown, stock movement history, material request usage.", "Delete – removes ALL batches for the item. Confirmation dialog appears."] },
      { title: "New Stock Adjustment", items: ["Navigate to Inventory → Stock Adjustment.", "Select an item to adjust.", "Specify Adjustment Type: Increase, Decrease, or Physical Count.", "Enter adjustment quantity, reason, and remarks.", "Click 'Submit Adjustment'."] },
      { title: "Stock Adjustment History", items: ["Navigate to Inventory → Stock Adjustment List.", "View total adjustments, stock increased, stock decreased, net change.", "Details: before/after quantities, item code, description, warehouse, batch, adjustment type, date, adjusted by, reason, remarks.", "Reverse Adjustment – confirmation dialog appears before reversing."] },
    ],
  },
  {
    id: "mr", code: "MRF", title: "Material Request Form", icon: "📝",
    color: "#0f766e", glow: "rgba(15,118,110,0.12)",
    description: "Request materials from inventory for your department. Fill in the Spare Parts Item Request Form and manage issued materials.",
    features: ["Request Information: Date, Name, A/R Invoice No., Control No., Department, Location, Purpose, Remarks", "Add requested items", "Save as draft or submit for approval", "View material requests in Goods Issue section", "Delete material requests (cannot be undone)"],
    steps: [
      { title: "Create Item Request Form", items: ["Navigate to Material Request Form → Item Request Form.", "Part 1 – Request Information: Enter Date, Name Requested By, A/R Invoice No., Control No., Department, Location, Purpose, and Remarks.", "Part 2 – Requested Items: Add items to the request.", "Save as draft or submit for approval."] },
      { title: "Goods Issue (View / Delete)", items: ["Navigate to Material Request Form → Goods Issue.", "View – click a request to see full details.", "Delete – confirmation dialog appears. Action CANNOT be undone."] },
    ],
  },
  {
    id: "approval", code: "APPR", title: "Approval", icon: "✅",
    color: "#1d4ed8", glow: "rgba(29,78,216,0.12)",
    description: "Manage the approval workflow for PRs, POs, and Material Requests. Includes approval history and multi-level approval management.",
    features: ["PR Approval – search by PR Number or Remarks", "PO Approval – search by PO Number, Vendor, or Location", "PR Approval History – Draft, Pending, Approved, Completed, Rejected", "PO Approval History – all PO statuses", "2nd PR Approval – multi-level approval management", "Material Request Approval"],
    steps: [
      { title: "PR Approval", items: ["Navigate to Approval → PR Approval.", "Search by PR Number or Remarks.", "View details: basic info, important dates, user info, remarks, PR items, and approval workflow."] },
      { title: "PO Approval", items: ["Navigate to Approval → PO Approval.", "Search by PO Number, Vendor, or Location.", "View details: vendor info, important dates, shipping details, PO items, and approval info."] },
      { title: "2nd PR Approval (Multi-level)", items: ["Navigate to Approval → 2nd PR Approval.", "Search by PR number or company.", "View pending levels and fully approved requests.", "View details: PR information, items requested, and approval signatures."] },
      { title: "Material Request Approval", items: ["Navigate to Approval → Material Request Approval.", "Search by PR number or company.", "View approval status including pending levels and fully approved requests."] },
    ],
  },
  {
    id: "reporting", code: "RPT", title: "Reporting", icon: "📈",
    color: "#15803d", glow: "rgba(21,128,61,0.12)",
    description: "Generate reports on procurement activities. View and manage all Purchase Requisitions, Purchase Orders, and Spare Parts Item Requests.",
    features: ["PR Reporting – search by PR number or remarks", "PO Reporting – search by PO number, location, or contact person", "RM Reports – search by Control No, A/R Invoice, Name, Department", "View totals: Total, Approved, Pending, Filtered", "Generate to Excel or PDF", "Create, View, Delete reports"],
    steps: [
      { title: "PR Reporting", items: ["Navigate to Reporting → PR Reporting.", "Search by PR number or remarks.", "View: Total PRs, Approved, Pending, Filtered requisitions.", "Click View to see details of a specific purchase requisition."] },
      { title: "PO Reporting", items: ["Navigate to Reporting → PO Reporting.", "Search by PO number, location, or contact person.", "View: Total POs, Approved, Pending, Filtered orders.", "Generate to Excel or PDF using the export button."] },
      { title: "RM / Spare Parts Reports", items: ["Navigate to Reporting → Rm Reports.", "Search by Control No, A/R Invoice, Name, or Department.", "View: Total Reports, Approved, Pending, Filtered.", "Create Report – start a new report.", "Delete – confirmation dialog appears. Action CANNOT be undone."] },
    ],
  },
  {
    id: "maintenance", code: "MAINT", title: "Maintenance", icon: "⚙️",
    color: "#0f172a", glow: "rgba(15,23,42,0.08)",
    description: "System maintenance and configuration. Manage all reference data including Departments, Companies, Locations, Vendors, Users, and more.",
    features: ["References: Departments, Companies, Locations, Vendors", "Shipping Information, Expense Types, Payment Methods", "User Levels & Position Level Access", "Approver Position Management (3 approval levels)", "Items Maintenance, Requestor Maintenance, Warehouses", "User Management, Inventory Destinations & Distribution", "License Management (password protected)", "Website Under Maintenance mode"],
    steps: [
      { title: "Departments", items: ["Navigate to Maintenance → References → Departments.", "Search by department name or code.", "Create New Department: enter department code and name.", "Edit / Delete departments. Export or Import department list."] },
      { title: "Companies", items: ["Navigate to Maintenance → References → Companies.", "Search by company name or code.", "Create New Company: enter company code, name, address, contact number, email, and TIN.", "Edit / Delete companies."] },
      { title: "Vendors", items: ["Navigate to Maintenance → References → Vendors.", "Search by vendor name, code, or contact person.", "Create New Vendor: enter vendor name, code, address, contact person, number, email, tax no, and payment terms.", "Edit / Delete vendors. Export or Import vendor list."] },
      { title: "User Management", items: ["Navigate to Maintenance → User Management.", "Create New User: profile picture, signature, username, password, personal information.", "Edit / Delete users."] },
      { title: "Approver Position Management", items: ["Navigate to Maintenance → References → Approver Position.", "Manage 3 approval levels and their PR/PO permissions.", "Click Edit to modify approval permissions for each level."] },
    ],
  },
  {
    id: "settings", code: "SET", title: "Settings", icon: "🔧",
    color: "#0369a1", glow: "rgba(3,105,161,0.12)",
    description: "Configure application license keys, manage your personal profile, and change your password.",
    features: ["Add New License Key with expiration date", "Edit / Remove license keys", "My Profile – manage personal information", "Change Password"],
    steps: [
      { title: "License Key Management", items: ["Navigate to Maintenance → Settings.", "Add New License Key: enter the license key and expiration date.", "Edit – modify an existing license key.", "Remove – delete a license key."] },
      { title: "My Profile", items: ["Click on your profile (bottom left corner) to show the menu.", "Click 'Edit Profile' to modify personal information.", "Click Save to confirm or Cancel to discard changes."] },
      { title: "Change Password", items: ["Navigate to Maintenance → Settings.", "Click 'Change Password'.", "Enter your current password and new password, then confirm and save."] },
    ],
  },
];

const stats = [
  { label: "Modules", value: "11", icon: "🧩" },
  { label: "Transaction Types", value: "7+", icon: "📊" },
  { label: "Reference Types", value: "15+", icon: "📁" },
  { label: "Approval Levels", value: "3", icon: "✅" },
];

const acronyms = [
  { term: "PR", def: "Purchase Request" }, { term: "PO", def: "Purchase Order" },
  { term: "GR", def: "Goods Receipt" }, { term: "REQ", def: "Request" },
  { term: "RM", def: "Reports Management" }, { term: "CTN", def: "Control Number" },
  { term: "UOM", def: "Unit Of Measure" }, { term: "PDF", def: "Portable Document Format" },
  { term: "JPG", def: "Joint Photographic Experts Group" }, { term: "PNG", def: "Portable Graphics Format" },
  { term: "DOCX", def: "Document (MS Word)" }, { term: "TIN", def: "Tax Identification Number" },
  { term: "QTY", def: "Quantity" }, { term: "VAT", def: "Value Added Tax" },
  { term: "DISC", def: "Discount" }, { term: "EX", def: "Excluding" },
];

const navItems = [
  { icon: "📊", label: "Dashboard", desc: "High-level overview of procurement activities" },
  { icon: "📋", label: "Purchase Request", desc: "Create and manage purchase requests" },
  { icon: "💬", label: "Quotation", desc: "Manage and compare quotations from suppliers" },
  { icon: "🛒", label: "Purchase Order", desc: "Create and manage purchase orders" },
  { icon: "📦", label: "Goods Receipt (GR)", desc: "Record the receipt of goods" },
  { icon: "🏭", label: "Inventory", desc: "Track and manage inventory levels" },
  { icon: "📝", label: "Material Request Form", desc: "Request materials from inventory" },
  { icon: "✅", label: "Approval", desc: "Manage approval workflow for documents" },
  { icon: "📈", label: "Reporting", desc: "Generate procurement reports" },
  { icon: "⚙️", label: "Maintenance", desc: "System maintenance and configuration" },
  { icon: "🔧", label: "Settings", desc: "Configure system settings and profile" },
];

export default function PRPOManual() {
  const [activeModule, setActiveModule] = useState(null);
  const [search, setSearch] = useState("");
  const [hovered, setHovered] = useState(null);
  const [showAcronyms, setShowAcronyms] = useState(false);
  const [activeStep, setActiveStep] = useState(null);
  const [showPDFList, setShowPDFList] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(null);

  const filtered = modules.filter(
    (m) =>
      m.title.toLowerCase().includes(search.toLowerCase()) ||
      m.code.toLowerCase().includes(search.toLowerCase()) ||
      m.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={s.root}>
      <div style={s.gridBg} />

      {/* NAVBAR */}
      <nav style={s.nav}>
        <div style={s.navLogo}>
          <div style={s.logoBox}>📑</div>
          <div>
            <div style={s.logoText}>PRPO Management System</div>
            <div style={s.logoSub}>User Manual</div>
          </div>
        </div>
        <div style={s.navRight}>
          <div style={s.navDot} />
          <button style={s.acronymBtn} onClick={() => setShowAcronyms(true)}>📖 Acronyms</button>
          <span style={{ fontSize: 11, color: "#64748b" }}>v1.0 · 2026</span>
        </div>
      </nav>

      {/* HERO */}
      <div style={s.main}>
        <div style={s.hero}>
          <div style={s.heroBadge}>📖 OFFICIAL DOCUMENTATION</div>
          <h1 style={s.heroTitle}>
            <span style={s.heroAccent}>PR-PO</span> Management System
          </h1>
          <p style={s.heroDesc}>
            PR-PO is a website designed to manage procurement processes within an organization. It handles purchase requests, quotations, purchase orders, approvals, reporting, and system maintenance.
          </p>

          <div style={s.statsRow}>
            {stats.map((st) => (
              <div key={st.label} style={s.statCard}>
                <div style={{ fontSize: 20 }}>{st.icon}</div>
                <div style={s.statValue}>{st.value}</div>
                <div style={s.statLabel}>{st.label}</div>
              </div>
            ))}
          </div>

          {/* Login */}
          <div style={s.loginBox}>
            <div style={s.loginTitle}>🔐 How to Login</div>
            <div style={s.loginSteps}>
              {["Open a web browser and go to your system URL.", "Enter your username and password correctly.", "Click the \"Sign in\" button to access the system."].map((step, i) => (
                <div key={i} style={s.loginStep}>
                  <span style={s.stepNum}>{i + 1}</span>
                  <span>{step}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Search + Download Buttons */}
          <div style={s.searchRow}>
            <div style={s.searchWrap}>
              <span style={{ color: "#94a3b8", fontSize: 14 }}>🔍</span>
              <input
                style={s.searchInput}
                placeholder="Search modules..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <button style={s.searchClear} onClick={() => setSearch("")}>✕</button>
              )}
            </div>
            {/* DOCX Download */}
            <button onClick={downloadDocx} style={s.downloadBtn} title="Download User Manual (.docx)">
              ⬇ Download Manual
            </button>
            {/* PDF List Button */}
            <button onClick={() => setShowPDFList(true)} style={{ ...s.downloadBtn, background: "linear-gradient(135deg, #15803d, #0f766e)" }} title="Download PDF Manuals">
              📄 PDFs
            </button>
          </div>
        </div>

        {/* MODULE GRID */}
        <div style={s.section}>
          <div style={s.sectionHeader}>
            <h2 style={s.sectionTitle}>System Modules</h2>
            <span style={s.sectionCount}>{filtered.length} of {modules.length}</span>
          </div>

          <div style={s.grid}>
            {filtered.map((mod) => (
              <div
                key={mod.id}
                style={{
                  ...s.card,
                  boxShadow: hovered === mod.id ? `0 8px 32px ${mod.glow}` : "0 2px 8px rgba(0,0,0,0.05)",
                  borderColor: hovered === mod.id ? mod.color + "44" : "#e2e8f0",
                  transform: hovered === mod.id ? "translateY(-3px)" : "none",
                }}
                onMouseEnter={() => setHovered(mod.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <div style={{ ...s.cardAccent, background: mod.color }} />
                <div style={s.cardHeader}>
                  <div style={{ ...s.cardIconBox, background: mod.color + "18" }}>
                    <span style={{ fontSize: 24 }}>{mod.icon}</span>
                  </div>
                  <span style={{ ...s.cardBadge, background: mod.color + "15", color: mod.color }}>
                    {mod.code}
                  </span>
                </div>
                <div style={s.cardTitle}>{mod.title}</div>
                <div style={s.cardDesc}>{mod.description}</div>
                <ul style={s.featureList}>
                  {mod.features.slice(0, 4).map((f, fi) => (
                    <li key={fi} style={s.featureItem}>
                      <div style={{ ...s.featureDot, background: mod.color }} />
                      <span>{f}</span>
                    </li>
                  ))}
                  {mod.features.length > 4 && (
                    <li style={{ ...s.featureItem, color: "#94a3b8", fontSize: 11 }}>
                      <div style={{ ...s.featureDot, background: "#cbd5e1" }} />
                      <span>+{mod.features.length - 4} more...</span>
                    </li>
                  )}
                </ul>
                <button
                  style={{ ...s.cardBtn, borderColor: mod.color, color: mod.color, background: mod.color + "0d" }}
                  onClick={() => { setActiveModule(mod); setActiveStep(null); }}
                >
                  📖 View Full Guide →
                </button>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div style={{ textAlign: "center", padding: "60px 24px", color: "#94a3b8" }}>
              <div style={{ fontSize: 36 }}>🔍</div>
              <div style={{ marginTop: 12, fontWeight: 600 }}>No modules found for "{search}"</div>
            </div>
          )}
        </div>

        {/* NAVIGATION GUIDE */}
        <div style={s.aboutSection}>
          <div style={s.aboutCard}>
            <div style={s.aboutBadge}>NAVIGATION</div>
            <h2 style={s.aboutTitle}>System Navigation</h2>
            <p style={s.aboutText}>
              <strong>Main Navigation Menu</strong><br />
              The left navigation menu provides access to all system modules. Other UI elements: 🔍 Search Menu (top left) · 🔔 Notifications Bell (top right) · 👤 User Profile (bottom left).
            </p>
            <div style={s.navGrid}>
              {navItems.map((item, i) => (
                <div key={i} style={s.navItem}>
                  <span style={{ fontSize: 18 }}>{item.icon}</span>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a" }}>{item.label}</div>
                    <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div style={s.footer}>
          <div style={{ fontWeight: 700, color: "#1d4ed8", marginBottom: 4 }}>📑 PRPO Management System</div>
          <div style={{ fontSize: 11, color: "#94a3b8" }}>User Manual Portal · All rights reserved · 2026</div>
        </div>
      </div>

      {/* MODULE DETAIL MODAL */}
      {activeModule && (
        <div style={s.overlay} onClick={() => setActiveModule(null)}>
          <div style={s.modal} onClick={(e) => e.stopPropagation()}>
            <div style={{ ...s.modalHeader, background: `linear-gradient(135deg, ${activeModule.color}, ${activeModule.color}cc)` }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 24 }}>{activeModule.icon}</span>
                <div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.7)", fontWeight: 700, letterSpacing: 1 }}>User Guide</div>
                  <div style={{ fontWeight: 800, color: "#fff", fontSize: 17, fontFamily: "'Syne', sans-serif" }}>{activeModule.title}</div>
                </div>
              </div>
              <button style={s.closeBtn} onClick={() => setActiveModule(null)}>✕</button>
            </div>
            <div style={s.modalBody}>
              <div style={s.descBox}>
                <div style={{ fontSize: 12, color: "#475569", lineHeight: 1.6 }}>{activeModule.description}</div>
              </div>
              <div style={s.featSection}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 10 }}>✨ Key Features</div>
                <div style={s.featGrid}>
                  {activeModule.features.map((f, fi) => (
                    <div key={fi} style={s.featItem}>
                      <div style={{ ...s.featureDot, background: activeModule.color, marginTop: 4, flexShrink: 0 }} />
                      <span style={{ fontSize: 12, color: "#374151" }}>{f}</span>
                    </div>
                  ))}
                </div>
              </div>
              {activeModule.steps && (
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 10 }}>📋 Step-by-Step Guide</div>
                  {activeModule.steps.map((step, si) => (
                    <div key={si} style={{ ...s.stepCard, marginBottom: 10 }}>
                      <button
                        style={{
                          ...s.stepHeader,
                          background: activeStep === si ? activeModule.color + "12" : "#f8fafc",
                          borderColor: activeStep === si ? activeModule.color + "44" : "#e2e8f0",
                          color: "#0f172a",
                        }}
                        onClick={() => setActiveStep(activeStep === si ? null : si)}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div style={{ ...s.stepNum2, background: activeModule.color }}>{si + 1}</div>
                          <span style={{ fontWeight: 700, fontSize: 13 }}>{step.title}</span>
                        </div>
                        <span style={{ color: "#94a3b8", transition: "transform 0.2s", display: "inline-block", transform: activeStep === si ? "rotate(180deg)" : "none" }}>▾</span>
                      </button>
                      {activeStep === si && (
                        <div style={s.stepBody}>
                          {step.items.map((item, ii) => (
                            <div key={ii} style={s.stepItem}>
                              <div style={{ ...s.stepBullet, background: activeModule.color }}>{ii + 1}</div>
                              <span style={{ fontSize: 12, color: "#374151", lineHeight: 1.6 }}>{item}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ACRONYMS MODAL */}
      {showAcronyms && (
        <div style={s.overlay} onClick={() => setShowAcronyms(false)}>
          <div style={{ ...s.modal, maxWidth: 520 }} onClick={(e) => e.stopPropagation()}>
            <div style={{ ...s.modalHeader, background: "linear-gradient(135deg, #1d4ed8, #0369a1)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 22 }}>📖</span>
                <div style={{ fontWeight: 800, color: "#fff", fontSize: 16 }}>Acronyms & Abbreviations</div>
              </div>
              <button style={s.closeBtn} onClick={() => setShowAcronyms(false)}>✕</button>
            </div>
            <div style={{ ...s.modalBody, padding: 0 }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={s.th}>TERM</th>
                    <th style={s.th}>DEFINITION</th>
                  </tr>
                </thead>
                <tbody>
                  {acronyms.map((a, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? "#f0f9ff" : "#fff" }}>
                      <td style={{ ...s.td, fontWeight: 700, color: "#1d4ed8" }}>{a.term}</td>
                      <td style={s.td}>{a.def}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* PDF LIST MODAL */}
      {showPDFList && (
        <div style={s.overlay} onClick={() => !downloading && setShowPDFList(false)}>
          <div style={{ ...s.modal, maxWidth: 580 }} onClick={(e) => e.stopPropagation()}>
            <div style={{ ...s.modalHeader, background: "linear-gradient(135deg, #15803d, #0f766e)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 22 }}>📄</span>
                <div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.7)", fontWeight: 700 }}>USER MANUAL</div>
                  <div style={{ fontWeight: 800, color: "#fff", fontSize: 16 }}>PDF Downloads ({PDF_FILES.length} files)</div>
                </div>
              </div>
              {!downloading && <button style={s.closeBtn} onClick={() => setShowPDFList(false)}>✕</button>}
            </div>
            <div style={{ ...s.modalBody, padding: "16px 20px", gap: 10 }}>
              
              {/* Progress bar */}
              {progress && (
                <div style={{ padding: "12px 16px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#15803d", marginBottom: 6 }}>
                    ⬇ Downloading {progress.current} of {progress.total}: {progress.name}
                  </div>
                  <div style={{ background: "#dcfce7", borderRadius: 100, height: 8, overflow: "hidden" }}>
                    <div style={{ width: `${(progress.current / progress.total) * 100}%`, height: "100%", background: "#15803d", borderRadius: 100, transition: "width 0.3s ease" }} />
                  </div>
                </div>
              )}

              {/* Download All button */}
              <button
                onClick={() => downloadAllPDFs(setProgress, setDownloading)}
                disabled={downloading}
                style={{
                  ...s.downloadBtn,
                  width: "100%",
                  justifyContent: "center",
                  background: downloading ? "#94a3b8" : "linear-gradient(135deg, #15803d, #0f766e)",
                  cursor: downloading ? "not-allowed" : "pointer",
                  fontSize: 14,
                  padding: "13px",
                }}
              >
                {downloading ? `⏳ Downloading... (${progress?.current || 0}/${PDF_FILES.length})` : `⬇ Download All ${PDF_FILES.length} PDFs`}
              </button>

              <div style={{ fontSize: 11, color: "#64748b", textAlign: "center" }}>
                💡 Tip: Ilagay lahat ng PDF sa <code style={{ background: "#f1f5f9", padding: "1px 5px", borderRadius: 4 }}>/public</code> folder ng project mo
              </div>

              {/* Individual PDF list */}
              <div style={{ maxHeight: 360, overflowY: "auto", display: "flex", flexDirection: "column", gap: 6 }}>
                {PDF_FILES.map((pdf, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 28, height: 28, background: "#fee2e2", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>📄</div>
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}>{pdf.name}</div>
                        <div style={{ fontSize: 10, color: "#94a3b8" }}>{pdf.file}</div>
                      </div>
                    </div>
                    <button
                      onClick={() => downloadFile(pdf.file, pdf.file)}
                      disabled={downloading}
                      style={{
                        padding: "6px 12px", background: "#eff6ff", border: "1px solid #bfdbfe",
                        borderRadius: 8, color: "#1d4ed8", fontSize: 11, fontWeight: 700,
                        cursor: downloading ? "not-allowed" : "pointer", fontFamily: "'DM Sans', sans-serif",
                        opacity: downloading ? 0.5 : 1,
                      }}
                    >
                      ⬇
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  root: { minHeight: "100vh", background: "#f0f9ff", color: "#0f172a", fontFamily: "'DM Sans', sans-serif", position: "relative", overflowX: "hidden" },
  gridBg: { position: "fixed", inset: 0, backgroundImage: "radial-gradient(#bae6fd 1px, transparent 1px)", backgroundSize: "28px 28px", pointerEvents: "none", zIndex: 0, opacity: 0.5 },
  nav: { position: "sticky", top: 0, zIndex: 100, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 48px", background: "rgba(255,255,255,0.95)", backdropFilter: "blur(20px)", borderBottom: "1px solid #bae6fd", boxShadow: "0 1px 8px rgba(3,105,161,0.08)" },
  navLogo: { display: "flex", alignItems: "center", gap: 12 },
  logoBox: { width: 40, height: 40, background: "linear-gradient(135deg, #1d4ed8, #06b6d4)", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 14px rgba(29,78,216,0.3)", fontSize: 18 },
  logoText: { fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 15, color: "#0f172a" },
  logoSub: { fontSize: 11, color: "#0369a1", fontWeight: 500, marginTop: 1 },
  navRight: { display: "flex", alignItems: "center", gap: 12 },
  navDot: { width: 8, height: 8, borderRadius: "50%", background: "#22c55e", boxShadow: "0 0 8px #22c55e88" },
  acronymBtn: { padding: "7px 14px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, color: "#1d4ed8", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" },
  main: { position: "relative", zIndex: 1 },
  hero: { textAlign: "center", padding: "70px 24px 50px", maxWidth: 900, margin: "0 auto" },
  heroBadge: { display: "inline-flex", padding: "6px 16px", background: "rgba(29,78,216,0.08)", border: "1px solid rgba(29,78,216,0.2)", borderRadius: 100, marginBottom: 20, fontSize: 11, fontWeight: 700, color: "#1d4ed8", letterSpacing: 1.5, textTransform: "uppercase" },
  heroTitle: { fontFamily: "'Syne', sans-serif", fontSize: "clamp(30px, 5vw, 58px)", fontWeight: 800, lineHeight: 1.1, letterSpacing: -1.5, marginBottom: 18, color: "#0f172a" },
  heroAccent: { background: "linear-gradient(90deg, #1d4ed8, #06b6d4)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
  heroDesc: { fontSize: "clamp(13px, 2vw, 16px)", color: "#475569", lineHeight: 1.7, maxWidth: 620, margin: "0 auto 36px" },
  statsRow: { display: "flex", justifyContent: "center", gap: 14, flexWrap: "wrap", marginBottom: 32 },
  statCard: { padding: "14px 22px", background: "#fff", border: "1px solid #bae6fd", borderRadius: 14, textAlign: "center", minWidth: 100, boxShadow: "0 2px 8px rgba(3,105,161,0.08)" },
  statValue: { fontFamily: "'Syne', sans-serif", fontSize: 26, fontWeight: 800, color: "#1d4ed8", lineHeight: 1 },
  statLabel: { fontSize: 10, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, marginTop: 4 },
  loginBox: { maxWidth: 500, margin: "0 auto 28px", padding: "18px 24px", background: "#fff", border: "1px solid #bae6fd", borderRadius: 14, boxShadow: "0 2px 8px rgba(3,105,161,0.06)", textAlign: "left" },
  loginTitle: { fontSize: 14, fontWeight: 700, color: "#0f172a", marginBottom: 12 },
  loginSteps: { display: "flex", flexDirection: "column", gap: 8 },
  loginStep: { display: "flex", alignItems: "flex-start", gap: 10, fontSize: 13, color: "#374151" },
  stepNum: { display: "inline-flex", width: 22, height: 22, background: "#1d4ed8", color: "#fff", borderRadius: "50%", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, flexShrink: 0 },
  searchRow: { display: "flex", alignItems: "center", gap: 10, maxWidth: 680, margin: "0 auto", flexWrap: "wrap", justifyContent: "center" },
  searchWrap: { flex: 1, minWidth: 200, display: "flex", alignItems: "center", gap: 10, background: "#fff", border: "1px solid #bae6fd", borderRadius: 12, padding: "12px 16px", boxShadow: "0 2px 8px rgba(3,105,161,0.06)" },
  searchInput: { flex: 1, background: "transparent", border: "none", color: "#0f172a", fontSize: 13, fontFamily: "'DM Sans', sans-serif", outline: "none" },
  searchClear: { background: "none", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: 14 },
  downloadBtn: { display: "inline-flex", alignItems: "center", gap: 6, padding: "12px 16px", background: "linear-gradient(135deg, #1d4ed8, #0369a1)", color: "#fff", borderRadius: 12, fontWeight: 700, fontSize: 13, textDecoration: "none", whiteSpace: "nowrap", border: "none", boxShadow: "0 4px 14px rgba(29,78,216,0.3)", transition: "all 0.2s ease", cursor: "pointer", fontFamily: "'DM Sans', sans-serif" },
  section: { maxWidth: 1280, margin: "0 auto", padding: "0 24px 70px" },
  sectionHeader: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 },
  sectionTitle: { fontFamily: "'Syne', sans-serif", fontSize: 22, fontWeight: 800, letterSpacing: -0.4, color: "#0f172a", margin: 0 },
  sectionCount: { fontSize: 12, color: "#0369a1", background: "#e0f2fe", padding: "4px 12px", borderRadius: 100, border: "1px solid #bae6fd", fontWeight: 600 },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 18 },
  card: { position: "relative", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 18, padding: "26px 22px 22px", overflow: "hidden", transition: "all 0.25s ease", cursor: "default" },
  cardAccent: { position: "absolute", top: 0, left: 0, right: 0, height: 3, borderRadius: "18px 18px 0 0" },
  cardHeader: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 14 },
  cardIconBox: { width: 52, height: 52, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" },
  cardBadge: { fontSize: 10, fontWeight: 800, padding: "3px 9px", borderRadius: 100, letterSpacing: 1, textTransform: "uppercase" },
  cardTitle: { fontFamily: "'Syne', sans-serif", fontSize: 17, fontWeight: 800, marginBottom: 8, letterSpacing: -0.2, color: "#0f172a" },
  cardDesc: { fontSize: 12, color: "#64748b", lineHeight: 1.6, marginBottom: 14 },
  featureList: { listStyle: "none", display: "flex", flexDirection: "column", gap: 6, padding: 0, margin: "0 0 18px 0" },
  featureItem: { display: "flex", alignItems: "flex-start", gap: 8, fontSize: 12, color: "#475569", fontWeight: 500 },
  featureDot: { width: 6, height: 6, borderRadius: "50%", flexShrink: 0, marginTop: 4 },
  cardBtn: { width: "100%", padding: "10px 14px", border: "1px solid", borderRadius: 10, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", display: "flex", alignItems: "center", gap: 6, transition: "all 0.2s ease" },
  aboutSection: { maxWidth: 1280, margin: "0 auto", padding: "0 24px 70px" },
  aboutCard: { background: "#fff", border: "1px solid #bae6fd", borderRadius: 20, padding: "40px", boxShadow: "0 4px 20px rgba(3,105,161,0.08)" },
  aboutBadge: { display: "inline-block", fontSize: 10, fontWeight: 700, color: "#1d4ed8", background: "rgba(29,78,216,0.08)", border: "1px solid rgba(29,78,216,0.2)", padding: "4px 12px", borderRadius: 100, letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 14 },
  aboutTitle: { fontFamily: "'Syne', sans-serif", fontSize: "clamp(20px, 3vw, 28px)", fontWeight: 800, letterSpacing: -0.6, marginBottom: 14, color: "#0f172a" },
  aboutText: { fontSize: 14, color: "#64748b", lineHeight: 1.7, marginBottom: 20 },
  navGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 10, marginTop: 16 },
  navItem: { display: "flex", alignItems: "flex-start", gap: 12, padding: "10px 14px", background: "#f0f9ff", borderRadius: 10, border: "1px solid #bae6fd" },
  footer: { textAlign: "center", padding: "28px 24px", borderTop: "1px solid #bae6fd", background: "#fff" },
  overlay: { position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)" },
  modal: { background: "#fff", borderRadius: 18, width: "100%", maxWidth: 760, maxHeight: "90vh", display: "flex", flexDirection: "column", overflow: "hidden", border: "1px solid #e2e8f0", boxShadow: "0 32px 80px rgba(0,0,0,0.2)" },
  modalHeader: { padding: "18px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 },
  modalBody: { padding: "24px", overflowY: "auto", display: "flex", flexDirection: "column", gap: 20 },
  closeBtn: { width: 34, height: 34, borderRadius: 8, background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  descBox: { padding: "14px 18px", background: "#f0f9ff", borderRadius: 12, border: "1px solid #bae6fd" },
  featSection: { padding: "16px 18px", background: "#f0f9ff", borderRadius: 12, border: "1px solid #bae6fd" },
  featGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 },
  featItem: { display: "flex", alignItems: "flex-start", gap: 8 },
  stepCard: { border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden" },
  stepHeader: { width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", border: "none", borderBottom: "1px solid #e2e8f0", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", transition: "all 0.2s" },
  stepNum2: { width: 26, height: 26, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 12, fontWeight: 800, flexShrink: 0 },
  stepBody: { padding: "14px 16px", display: "flex", flexDirection: "column", gap: 10, background: "#fff" },
  stepItem: { display: "flex", alignItems: "flex-start", gap: 10 },
  stepBullet: { width: 20, height: 20, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 10, fontWeight: 700, flexShrink: 0, marginTop: 2 },
  th: { padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#fff", background: "#1d4ed8", textTransform: "uppercase", letterSpacing: 0.5 },
  td: { padding: "9px 16px", fontSize: 13, color: "#374151", borderBottom: "1px solid #f1f5f9" },
};